/**
 * SegeraHadirModal — paywall teaser placeholder (plan 16 Phase C).
 *
 * Menampilkan teaser "Fitur Premium Segera Hadir" — TIDAK ada flow
 * pembayaran (PAYWALL_ENABLED=false). Satu tombol "Siap, Ditunggu!"
 * untuk menutup modal.
 *
 * Dibangun di atas RN Modal (pola sama dengan ConfirmationModal).
 */

import { Modal, Pressable, StyleSheet, Text, View } from 'react-native';

import { Brand, Radii, Spacing } from '@/constants/theme';
import { PREMIUM_CATALOG_TEASER_COUNT } from '@funpaper/shared';

interface SegeraHadirModalProps {
  visible: boolean;
  onClose: () => void;
  /** Override copy — dipakai varian login (plan 19) dsb. Default = teaser premium. */
  title?: string;
  body?: string;
  ctaLabel?: string;
  /** Default: onClose. Varian login mengarahkan ke /login. */
  onCtaPress?: () => void;
}

export function SegeraHadirModal({
  visible,
  onClose,
  title,
  body,
  ctaLabel,
  onCtaPress,
}: SegeraHadirModalProps) {
  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <Pressable style={styles.backdrop} onPress={onClose}>
        {/* Inner Pressable mencegah tap backdrop menutup saat tap di kartu. */}
        <Pressable style={styles.card} onPress={(e) => e.stopPropagation?.()}>
          <Text style={styles.emoji}>🎉</Text>
          <Text style={styles.title}>{title ?? 'Fitur Premium Segera Hadir'}</Text>
          <Text style={styles.body}>
            {body ??
              `Buka akses ke ${PREMIUM_CATALOG_TEASER_COUNT} worksheet tematik, extra worksheet harian, dan rencana aktivitas mingguan untuk si kecil.`}
          </Text>
          <Pressable
            onPress={onCtaPress ?? onClose}
            style={({ pressed }) => [styles.cta, pressed && styles.ctaPressed]}
            accessibilityRole="button"
            accessibilityLabel={ctaLabel ?? 'Siap, Ditunggu!'}
          >
            <Text style={styles.ctaText}>{ctaLabel ?? 'Siap, Ditunggu!'}</Text>
          </Pressable>
        </Pressable>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    alignItems: 'center',
    justifyContent: 'center',
    padding: Spacing.four,
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: Radii.medium,
    padding: Spacing.four,
    width: '100%',
    maxWidth: 360,
    alignItems: 'center',
    gap: Spacing.two,
  },
  emoji: {
    fontSize: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1A0B5C',
    textAlign: 'center',
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
    color: '#4b5563',
    textAlign: 'center',
  },
  cta: {
    alignSelf: 'stretch',
    marginTop: Spacing.two,
    backgroundColor: Brand.primary,
    paddingVertical: 12,
    borderRadius: Radii.small,
    alignItems: 'center',
  },
  ctaText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '700',
  },
  ctaPressed: {
    opacity: 0.75,
  },
});
